import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type ExportRulesDrawerParagraphProps = {
  title: string;
  description: string;
};

export const ExportRulesDrawerParagraph = ({ title, description }: ExportRulesDrawerParagraphProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      <Typography variant="body1Bold">{title}</Typography>
      <Typography variant="body1">{description}</Typography>
    </Box>
  );
};
